// moduli
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
// servizi
import { HttpClient } from "@angular/common/http";
// componenti
import { ListComponent } from "./list.component";
import { GeneraPDFModule } from "./servizi/genera-pdf/genera-pdf.module";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [ListComponent],
  imports: [CommonModule, FontAwesomeModule, NgbModule, FormsModule, HttpClientModule, GeneraPDFModule],
  providers: [HttpClient],
  exports: [ListComponent],
})
export class ListModule {}
